import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.4rem;

  @media (max-width: 768px) {
    padding-top: 1rem;
  }
`
